import React from 'react';

import { LinkStyled } from './link-styled-component';

const LinkA = props => {
  return <LinkStyled {...props}></LinkStyled>;
};

export default LinkA;
